import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Box from '@mui/material/Box';
import { useState } from 'react';
import CountryPrice from './CountryPrice';
import BudgetItem from './BudgetItem';
import { grey } from '@mui/material/colors';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  tab: {
    color: grey[300],
    opacity: '75%',
    '&.Mui-selected': {
      opacity: '100%',
      color: '#80CBC4',
    },
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`budget-tabpanel-${index}`}
      aria-labelledby={`budget-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `budget-tab-${index}`,
    'aria-controls': `budget-tabpanel-${index}`,
  };
}

export default function BudgetTabs({
  budget,
  currency,
  hotelLink,
  rentalCarLink,
  busLink,
  privateDriverLink,
  taxiLink,
  viatorLink,
  countryCode,
}) {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const { classes } = useStyles();

  const budgetBackpack = Math.round(
    budget.hostelDormMedianPrice +
      budget.takeawayMeal * 1.5 +
      budget.localPublicTransport +
      budget.longDistanceTransport * 0.3 +
      budget.attractions * 0.5 +
      budget.beerPrice,
  );
  const budgetNomad = Math.round(
    budget.airbnbOneNightMedianPrice +
      budget.deliveryMeal +
      budget.taxiRide +
      budget.coffeePrice,
  );
  const budgetComfort = Math.round(
    budget.hotelMedianPrice +
      budget.rentalCar +
      budget.organizedTour +
      budget.restaurantMeal,
  );
  const budgetLuxury = Math.round(
    budget.fiveStarHotelMedianPrice +
      budget.fineDining +
      budget.privateDriver +
      budget.privateDayTrip,
  );

  return (
    <>
      <Box
        // sx={{ borderBottom: 1, borderColor: 'divider' }}
        className="-tw-mt-4"
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="budget tabs"
          TabIndicatorProps={{
            style: {
              backgroundColor: '#80CBC4',
            },
          }}
          centered
          variant="fullWidth"
        >
          <Tab
            className={classes.tab}
            label={
              <>
                <span className="tw-block md:tw-hidden xl:tw-block">
                  Backpacker
                </span>
                <span className="tw-hidden md:tw-block xl:tw-hidden">$</span>
              </>
            }
            {...a11yProps(0)}
            style={{ minWidth: '25%' }}
          />{' '}
          <Tab
            className={classes.tab}
            label={
              <>
                <span className="tw-block md:tw-hidden xl:tw-block">Nomad</span>
                <span className="tw-hidden md:tw-block xl:tw-hidden">$$</span>
              </>
            }
            {...a11yProps(1)}
            style={{ minWidth: '25%' }}
          />
          <Tab
            className={classes.tab}
            label={
              <>
                <span className="tw-block md:tw-hidden xl:tw-block">
                  Comfort
                </span>
                <span className="tw-hidden md:tw-block xl:tw-hidden">$$$</span>
              </>
            }
            {...a11yProps(2)}
            style={{ minWidth: '25%' }}
          />
          <Tab
            className={classes.tab}
            label={
              <>
                <span className="tw-block md:tw-hidden xl:tw-block">
                  Luxury
                </span>
                <span className="tw-hidden md:tw-block xl:tw-hidden">$$$$</span>
              </>
            }
            {...a11yProps(3)}
            style={{ minWidth: '25%' }}
          />
        </Tabs>
      </Box>
      <div className="linkUnderline">
        <TabPanel value={value} index={0}>
          <h3 className="tw-font-bold text-white pt-2 tw-text-2xl">
            <span className="tw-hidden md:tw-inline-block xl:tw-hidden">
              Backpacker
            </span>{' '}
            Budget:{' '}
            <CountryPrice currency={currency} priceUsd={budgetBackpack} />
          </h3>
          <table className="tw-w-full">
            <tbody>
              <BudgetItem
                noBorder
                externalLink="https://hostelworld.tp.st/ANPDOIh2"
                category="Hostel Dorm"
                currency={currency}
                priceUsd={budget.hostelDormMedianPrice}
              />
              <BudgetItem
                category="Takeaway Meal"
                currency={currency}
                priceUsd={budget.takeawayMeal}
              />
              <BudgetItem
                category="Public transport"
                currency={currency}
                priceUsd={budget.localPublicTransport}
              />
              <BudgetItem
                category="Long-distance bus"
                externalLink={busLink}
                currency={currency}
                priceUsd={budget.longDistanceTransport}
              />
              <BudgetItem
                category="Entrance Fee"
                currency={currency}
                priceUsd={budget.attractions}
                externalLink="https://tiqets.tp.st/Lyf4ymwK"
              />
              <BudgetItem
                category="Beer"
                currency={currency}
                priceUsd={budget.beerPrice}
              />
            </tbody>
          </table>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <h3 className="tw-font-bold text-white pt-2 tw-text-2xl">
            <span className="tw-hidden md:tw-inline-block xl:tw-hidden">
              Nomad
            </span>{' '}
            Budget: <CountryPrice currency={currency} priceUsd={budgetNomad} />
          </h3>
          <table className="tw-w-full">
            <tbody>
              <BudgetItem
                noBorder
                externalLink="https://vrbo.tp.st/66qlj8bj"
                category={
                  countryCode === 'cu' ? 'Casa Particular' : 'Apartment'
                }
                currency={currency}
                priceUsd={budget.airbnbOneNightMedianPrice}
              />
              <BudgetItem
                category="Delivery Meal"
                currency={currency}
                priceUsd={budget.deliveryMeal}
              />
              <BudgetItem
                category="Short Taxi Ride"
                externalLink={taxiLink}
                currency={currency}
                priceUsd={budget.taxiRide}
              />
              <BudgetItem
                category="Coffee"
                currency={currency}
                priceUsd={budget.coffeePrice}
              />
            </tbody>
          </table>
        </TabPanel>
        <TabPanel value={value} index={2}>
          <h3 className="tw-font-bold text-white pt-2 tw-text-2xl">
            <span className="tw-hidden md:tw-inline-block xl:tw-hidden">
              Comfort
            </span>{' '}
            Budget:{' '}
            <CountryPrice currency={currency} priceUsd={budgetComfort} />
          </h3>
          <table className="tw-w-full">
            <tbody>
              <BudgetItem
                noBorder
                externalLink={hotelLink}
                category="Hotel"
                currency={currency}
                priceUsd={budget.hotelMedianPrice}
              />
              <BudgetItem
                category="Rental Car"
                externalLink={rentalCarLink}
                currency={currency}
                priceUsd={budget.rentalCar}
              />
              <BudgetItem
                category="Organized Tour"
                externalLink={viatorLink}
                currency={currency}
                priceUsd={budget.organizedTour}
              />
              <BudgetItem
                category="Restaurant"
                currency={currency}
                priceUsd={budget.restaurantMeal}
              />
            </tbody>
          </table>
        </TabPanel>
        <TabPanel value={value} index={3}>
          <h3 className="tw-font-bold text-white pt-2 tw-text-2xl">
            <span className="tw-hidden md:tw-inline-block xl:tw-hidden">
              Luxury
            </span>{' '}
            Budget: <CountryPrice currency={currency} priceUsd={budgetLuxury} />
          </h3>
          <table className="tw-w-full">
            <tbody>
              <BudgetItem
                noBorder
                category="5 Star Hotel"
                externalLink={hotelLink}
                currency={currency}
                priceUsd={budget.fiveStarHotelMedianPrice}
              />
              <BudgetItem
                category="Fine Dining"
                currency={currency}
                priceUsd={budget.fineDining}
              />
              <BudgetItem
                category="Private transport"
                externalLink={privateDriverLink}
                currency={currency}
                priceUsd={budget.privateDriver}
              />
              <BudgetItem
                category="Private day trip"
                externalLink={viatorLink}
                currency={currency}
                priceUsd={budget.privateDayTrip}
              />
            </tbody>
          </table>
        </TabPanel>
      </div>
    </>
  );
}
